import React, { createContext, useState, useContext, useEffect } from "react";
import { getData } from "./api";

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [selectedProject, setSelectedProject] = useState("Default");
  const [selectedAvatare, setSelectedAvatare] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [profile, setProfile] = useState(null);
  const [avatares,setAvatares] =useState([])

  const [data, setData] = useState(null);
  const [openApps, setOpenApps] = useState(false);
  const [isSuperAdim, setIsSupperAdmin] = useState(false);
  useEffect(() => {
    const init = async () => {
      await fetchProjects();
      await getData(setAvatares);
    };
  
    init();
  }, [fetched]);
  
  const fetchProjects = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_ROOT_SEQUENTIAL}/api/ppt/get-projects/`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const result = await res.json();
      setData(result);
  
      if (result.length === 1) {
        setSelectedProject(result[0].project);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };
  
  

  return (
    <SidebarContext.Provider
      value={{
        openApps,
        avatares,
        setAvatares,
        selectedAvatare,
        setSelectedAvatare,
        setOpenApps,
        isSidebarOpen,
        setIsSidebarOpen,
        selectedProject,
        setSelectedProject,
        data,
        isModalOpen,
        setIsModalOpen,
        fetched,
        setFetched,
        profile,
        setProfile,
        isSuperAdim,
        setIsSupperAdmin,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => {
  return useContext(SidebarContext);
};
